import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { expiresAt: String }
  static targets = ["display"]

  connect() {
    this.tick()
    this.interval = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    clearInterval(this.interval)
  }

  tick() {
    if (!this.hasDisplayTarget) return
    const expiresAt = new Date(this.expiresAtValue).getTime()
    const remaining = Math.max(0, Math.floor((expiresAt - Date.now()) / 1000))
    if (remaining === 0) {
      this.displayTarget.textContent = "Expired"
      this.displayTarget.classList.add("text-red-700", "dark:text-red-400")
      clearInterval(this.interval)
      return
    }
    const minutes = Math.floor(remaining / 60).toString().padStart(2, "0")
    const seconds = (remaining % 60).toString().padStart(2, "0")
    this.displayTarget.textContent = `${minutes}:${seconds}`
  }
}
